<template>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
			
			<!-- Header -->
                <HeaderMain />
			<!-- /Header -->
			
			<!--Section Banner-->	
                <Banner />
			<!--/Section Banner-->	

			<!--Section Benefits-->	
                <!-- <Benefits /> -->
			<!--/Section Benefits-->	

			<!--Section Top Schools-->	
                <!-- <TopSchools /> -->
			<!--/Section Top Schools-->	

			<!--Section Top Courses-->	
                <!-- <TopCourses /> -->
			<!--/Section Top Courses-->	

			<!--Section Count-->	
                <!-- <Count /> -->
			<!--/Section Count-->		

			<!--Section Top Instructors-->	
                <!-- <TopInstructors /> -->
			<!--/Section Top Instructors-->	

			<!--Section Featured School-->	
                <!-- <FeaturedSchool /> -->
			<!--/Section Featured School-->	

			<!--Section Blog-->	
                <!-- <FeaturedBlog /> -->
			<!--/Section Blog-->	

			<!--Section Enrollment-->	
                <!-- <Enrollment /> -->
			<!--/Section Enrollment-->	

			<!--Section Review-->	
                <!-- <Reviews /> -->
			<!--/Section Review-->	

			<!-- Footer -->
                <!-- <layout-footer /> -->
                <Footer/>
			<!-- /Footer -->
			
            
		</div>
		<!-- /Main Wrapper -->
</template>

<script>
import HeaderMain from '../Layout/HeaderMain'
import Footer from '../Layout/Footer'
import Banner from '../Home/Banner'
import Benefits from '../Home/Benefits'
import TopSchools from '../Home/TopSchools'
import TopCourses from '../Home/TopCourses'
import TopInstructors from '../Home/TopInstructors'
import Count from '../Home/Count'
import FeaturedSchool from '../Home/FeaturedSchool'
import FeaturedBlog from '../Home/FeaturedBlog'
import Enrollment from '../Home/Enrollment'
import Reviews from '../Home/Reviews'
import store from '../../store'

export default {
    components: {
		HeaderMain,
        Banner,
        Benefits,
        TopSchools,
        TopCourses,
        TopInstructors,
        Count,
        FeaturedSchool,
        FeaturedBlog,
        Enrollment,
        Reviews, Footer
    },
    beforeCreate () {
        if (!localStorage.getItem('token')) {
            // this.$router.push({ name: 'login' })
            store.dispatch("checktoken");
        }
    },
    created: function () {
        if(localStorage.getItem('token')){
            store.dispatch("checktoken");
        }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Home/index.vue